module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auctions"
  }, [_c('div', {
    staticClass: "media-box"
  }, [_c('h2', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_vm._v(_vm._s(_vm.$t('infoBox.newsTitle')))]), _vm._v(" "), _vm._l((_vm.news), function(item, index) {
    return (_vm.lang === 'pl') ? _c('div', {
      key: item.title + index,
      staticClass: "news-container",
      attrs: {
        "data-aos": "fade-up"
      }
    }, [(item.img) ? _c('div', {
      staticClass: "foto"
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": item.title
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "title",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "info",
      domProps: {
        "innerHTML": _vm._s(item.body)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "posted"
    }, [_c('p', {
      staticClass: "par_posted"
    }, [_vm._v(_vm._s(_vm.$t('infoBox.postedDescription')) + " " + _vm._s(item.date))])])])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.news_en), function(item, index) {
    return (_vm.lang !== 'pl') ? _c('div', {
      key: item.title + index,
      staticClass: "news-container",
      attrs: {
        "data-aos": "fade-up"
      }
    }, [(item.img) ? _c('div', {
      staticClass: "foto"
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": item.title
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "title",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "info",
      domProps: {
        "innerHTML": _vm._s(item.body)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "posted"
    }, [_c('p', {
      staticClass: "par_posted"
    }, [_vm._v(_vm._s(_vm.$t('infoBox.postedDescription')) + " " + _vm._s(item.date) + " ")])])])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.$t('infoBox.infoBoxes')), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "news-container",
      attrs: {
        "data-aos": "fade-up"
      }
    }, [(item.img) ? _c('div', {
      staticClass: "foto"
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": item.title
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "title",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "info",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    }), _vm._v(" "), (item.video) ? _c('div', {
      staticClass: "video-container"
    }, [_c('video', {
      attrs: {
        "src": item.video,
        "poster": item.poster,
        "controls": ""
      }
    })]) : _vm._e(), _vm._v(" "), (item.link) ? _c('div', {
      staticClass: "link"
    }, [_vm._v(_vm._s(_vm.$t('infoBox.linkDescription')) + "\n          "), _c('a', {
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fas fa-link"
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "posted"
    }, [_c('p', {
      staticClass: "par_posted"
    }, [_vm._v(_vm._s(_vm.$t('infoBox.postedDescription')) + " " + _vm._s(item.date) + " ")])])]), _vm._v(" "), _c('hr', {
      staticClass: "separate"
    })])
  }), _vm._v(" "), _c('vs-collapse', [_c('vs-collapse-item', {
    attrs: {
      "not-arrow": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', {
    staticClass: "archive",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-double-right"
  }), _vm._v(" " + _vm._s(_vm.$t('infoBox.archiveTitle')) + " "), _c('i', {
    staticClass: "fas fa-angle-double-left"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-box centered"
  }, _vm._l((_vm.$t('mediaBox.mediaBoxes')), function(item, index) {
    return _c('a', {
      key: index,
      class: ['box', item.type],
      attrs: {
        "target": "_blank",
        "href": item.link,
        "data-aos": "fade-up"
      }
    }, [_c('div', {
      staticClass: "image"
    }, [_c('div', {
      staticClass: "img",
      style: ({
        backgroundImage: 'url(' + item.img + ')'
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('span', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    })])])
  }), 0)])], 1)], 2), _vm._v(" "), _c('footer-main')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46f2fd5a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Infonews.vue
// module id = 291
// module chunks = 0